import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { translate, showMessageToastCustom } from '../../../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../../../utils/handleChangeHooks';
import { Breadcrumbs, Button, Input, Select } from '../../../../../components/UI/ComponentsUI';
import StockService from '../../../../../services/StockService';
import ConfirmModal from '../../../../../components/UI/ConfirmModal'; 
import { ENUMS } from '../../../../../utils/constants';

const QuestionInsert = (props) => {
    const update = props.location?.state?.update;
    const [question, setQuestion] = useState({
        description: undefined,
        answers: [], 
        type: ENUMS.eFormType.Deem.value,
    });
    const [selectedAnswer, setSelectedAnswer] = useState({});
    const [editMode, setEditMode] = useState(); 
    const [newDescription, setNewDescription] = useState(undefined);

    const onChange = (event) => {
        onValueChange(event, question, setQuestion);
    };

    useEffect(() => {
        if (props.location?.state?.update && props.location?.state?.questionId) {
            searchQuestion()
        }

        // eslint-disable-next-line
    }, []);

    const searchQuestion = () => {
        props.getQuestion(props.location?.state?.questionId, (response) => {
            setQuestion(response)
        });
    }

    const onConfirm = () => {
        if (validateInputsRequired("formMovementTypeInsert")) {
            if (update) {
                props.questionUpdate(question, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.questionInsert(question, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const titleMovementType = { icon: "mdi mdi-clipboard-check-outline", label: translate('questions', 'stock') };
    const subtitlesMovementType = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    const onDelete = () => {
        props.deleteAnswer(selectedAnswer.id, () => {
            setSelectedAnswer({})
            const modal = M.Modal.init(document.getElementById('confirmDelete'));
            modal.close(); 
            showMessageToastCustom(translate('general.info'), translate('sucess-to-delete', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            searchQuestion()
        })
    }

    const onClickDelete = (item) => {
        setSelectedAnswer(item)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    }

    const saveEdition = (item) => {
        props.answerUpdate(item, (response) => {
            if (!response) {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                props.history.go(-1);
            }

            setSelectedAnswer({})
        })
    }

    const cancelEdition = (value) => {
        setSelectedAnswer({})
        onEdit(value)
        setEditMode(false)
    }

    const onEdit = (value) => {
        let list = [];
        Object.assign(list, question.answers);
        let field = list.find((data) => data.id === selectedAnswer.id);
        field.description = value;

        setQuestion({ ...question, answers: list });
    }

    const onClickEdit = (item) => {
        let selected = [];
        Object.assign(selected, item);
        setSelectedAnswer(selected)
        setEditMode(true)
    }

    const addAnswer = (value) => {
        if (validateInputsRequired("newDescription")) {
            if (update) {
                let dto = {
                    questionId: question.id,
                    description: value
                }
                props.answerInsert(dto, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        searchQuestion()
                    }
                })
            } else { 
                let selected = [];
                Object.assign(selected, question);
                selected.answers.push({
                    description: value
                })
                setQuestion(selected)
                setNewDescription(undefined)
            }
        }
    }

    return (
        <div>
            <Breadcrumbs id="partnumberinsert" title={titleMovementType} subtitles={subtitlesMovementType()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formMovementTypeInsert">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            id="description"
                                            name='description'
                                            placeholder={translate('stock:description')}
                                            type="text"
                                            defaultValue={question.description || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            required
                                            id="type"
                                            name="type" 
                                            placeHolder={translate('choose-one-option', 'general')}
                                            data={[{ id: ENUMS.eFormType.Deem.value, text: ENUMS.eFormType.Deem.text },
                                                { id: ENUMS.eFormType.Sqp.value, text: ENUMS.eFormType.Sqp.text }]} 
                                            change={onChange}
                                            defaultValue={question.type}
                                        />
                                    </div>
                                </div>
                                <div>
                                </div>
                                {question.answers?.length > 0 &&
                                    <div>
                                        {translate('stock:questions')}
                                        <div>
                                            {question.answers?.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px' }}
                                                    >
                                                        <Input
                                                            disabled={selectedAnswer.id !== item.id || !update}
                                                            required
                                                            id="answer"
                                                            name='answer'
                                                            placeholder={translate('stock:answer')}
                                                            type="text"
                                                            value={item.description}
                                                            onChange={(event) => onEdit(event.target.value)}
                                                            maxLength="100"
                                                        />
                                                        {((selectedAnswer.id !== item.id) || !editMode) && update ?
                                                            <>
                                                                <span className="above-btn sixth-text-color right">
                                                                    <i style={{ cursor: 'pointer' }} onClick={() => onClickEdit(item)} className="mdi mdi-lead-pencil"></i>
                                                                </span>
                                                                <span className="above-btn sixth-text-color right">
                                                                    <i style={{ cursor: 'pointer' }} onClick={() => onClickDelete(item)} className="mdi mdi-delete"></i>
                                                                </span>
                                                            </>
                                                            : null}
                                                        {selectedAnswer.id === item.id && editMode ?
                                                            <>
                                                                <span className="above-btn sixth-text-color right">
                                                                    <i style={{ cursor: 'pointer' }} onClick={() => saveEdition(item)} className="mdi mdi-check-circle" disabled={selectedAnswer.id !== item.id}></i>
                                                                </span>
                                                                <span className="above-btn sixth-text-color right">
                                                                    <i style={{ cursor: 'pointer' }} onClick={() => cancelEdition(selectedAnswer.description)} className="mdi mdi-close-circle-outline" disabled={selectedAnswer.id !== item.id}></i>
                                                                </span>
                                                            </>
                                                            : null}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                }
                            </form>
                            <form id="newDescription">
                                <div className="row">
                                    <div className="input-field no-padding col s10" style={{ marginTop: '10px' }}> 
                                        <Input 
                                            required
                                            disabled={selectedAnswer.id}
                                            id="newDescription"
                                            name='newDescription'
                                            placeholder={translate('stock:answer')}
                                            type="text"
                                            value={newDescription}
                                            onChange={(event) => setNewDescription(event.target.value)}
                                        />
                                    </div>
                                    <div className="col s1" style={{ paddingTop: '10px' }}>
                                        <button
                                            disabled={selectedAnswer.id}
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => addAnswer(newDescription)}
                                        >
                                            <i className={`mdi mdi-plus`} />
                                        </button>
                                    </div>
                                </div> 
                            </form>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" disabled={selectedAnswer.id} />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} disabled={selectedAnswer.id} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            /> 
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        question: state.stockReducer.question,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        questionInsert: (question, callback) => {
            dispatch(StockService.addQuestion(question, callback));
        },
        questionUpdate: (question, callback) => {
            dispatch(StockService.editQuestion(question, callback));
        },
        getQuestion: (questionId, callback) => {
            dispatch(StockService.getQuestion(questionId, callback));
        },
        deleteAnswer: (questionId, callback) => {
            dispatch(StockService.deleteAnswer(questionId, callback));
        },
        answerUpdate: (answer, callback) => {
            dispatch(StockService.editAnswer(answer, callback));
        },
        answerInsert: (answer, callback) => {
            dispatch(StockService.addAnswer(answer, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(QuestionInsert)));
